import { render, staticRenderFns } from "./UserSalesBarChart.vue?vue&type=template&id=5d645c60&scoped=true&"
import script from "./UserSalesBarChart.vue?vue&type=script&lang=js&"
export * from "./UserSalesBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d645c60",
  null
  
)

export default component.exports